// Our custom error messages don't have codes so we have to use the message
export const PERMISSION_ERROR = "You don't have permission to access that user test";
export const MUST_PASS_ID = 'You must pass `id`, `pk` or `uuid` to fetch a user test';
export const DOES_NOT_EXIST = 'This UserTest does not exist';
// slightly different wording returned from graphql depending on whether we query by pk or uuid
// remove this variation when this ticket is addressed https://linear.app/ballpark/issue/BALL-1069/error-messaging-should-be-consistent
export const DOES_NOT_EXIST_VARIATION = 'That user test does not exist';
